// Mainly auto generated code
// TODO - needs verification

import { trim, validatePostcodeForCountry } from '@/utils/validation.ts'

export type CreateOrganization = {
  organizationNumber: string
  organizationName: string
  streetName: string
  houseNumber?: number
  houseNumberSuffix: string
  postalCode: string
  city: string
  country: string
  isPrivateOrganization: boolean
  owner: boolean
}

export type CreateOrganizationErrors = Partial<Record<keyof CreateOrganization, string>>

export function createOrganization(owner = false): CreateOrganization {
  return {
    organizationNumber: '',
    organizationName: '',
    streetName: '',
    houseNumberSuffix: '',
    postalCode: '',
    city: '',
    country: '',
    isPrivateOrganization: false,
    owner,
  }
}

export function validateCreateOrganization(
  data: Partial<CreateOrganization>,
  errors: CreateOrganizationErrors | undefined = {}
): data is CreateOrganization {
  if (!trim(data.organizationName)) {
    errors.organizationName = 'Organisatienaam is verplicht'
  }

  // Ondernemingsnummer (required, basic sanity)
  const orgNum = trim(data.organizationNumber)
  if (!orgNum && !data.isPrivateOrganization) {
    errors.organizationNumber = 'Ondernemingsnummer is verplicht'
  }

  // Straatnaam (required)
  if (!trim(data.streetName)) {
    errors.streetName = 'Straatnaam is verplicht'
  }

  // Huisnummer (optional, but if present must be >= 1)
  if (data.houseNumber != null && data.houseNumber.toString() != '') {
    if (Number.isNaN(data.houseNumber)) {
      errors.houseNumber = 'Huisnummer is ongeldig'
    } else if (data.houseNumber <= 0) {
      errors.houseNumber = 'Huisnummer moet groter dan 0 zijn'
    }
  }

  // Toevoeging (optional, soft rule)
  if (trim(data.houseNumberSuffix) && trim(data.houseNumberSuffix).length > 20) {
    errors.houseNumberSuffix = 'Toevoeging is te lang'
  }

  // Land (required, but free-form)
  if (!trim(data.country)) {
    errors.country = 'Land is verplicht'
  }

  if (!trim(data.postalCode)) {
    errors.postalCode = 'Postcode is verplicht'
  }

  // Postcode (required, but country-dependent validation)
  if (data.postalCode && data.country) {
    const postalCodeError = validatePostcodeForCountry(data.postalCode, data.country)
    if (postalCodeError) {
      errors.postalCode = postalCodeError
    }
  }

  // Stad (required)
  if (!trim(data.city)) {
    errors.city = 'Stad is verplicht'
  }

  return Object.keys(errors).length < 1
}
